<template>
  <div class="carousel-container">
    <img src="../assets/images/pictures/marriage.jpg" alt="carousel-image" class="carousel-image">
    <div class="carousel-text">
      <h1>Create Beautiful Event Programmes <br> With Lasting Experiences</h1>
      <p>CodedEvents helps you create beautiful event programmes with lasting experiences</p>
      <button class="create-event">Create An Event</button>
    </div>
    <div class="switch-button">
      <h2 class="prev-btn" style="transform: rotate(180deg)"> <img src="../assets/images/icons/arrow.svg" alt=""></h2>
      <h2 class="next-btn"> <img src="../assets/images/icons/arrow.svg" alt=""></h2>
    </div>
  </div>
</template>
